import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

// fields: [{ key, label, unit, testid, fmt }]
// values: { key: number }, field: active key, raw: string
export function TrioInputs({ fields, values, field, raw, onEdit, disabled }) {
  return (
    <div className="grid grid-cols-3 gap-2">
      {fields.map((f) => {
        const active = f.key === field;
        const num = values[f.key] || 0;
        const display = active ? raw : num ? f.fmt(num) : "";
        return (
          <label key={f.key} className="block">
            <span className="mb-1.5 block text-[11px] font-semibold uppercase tracking-wider text-slate-400">
              {f.label}
            </span>
            <div className="relative">
              <Input
                inputMode="decimal"
                disabled={disabled}
                data-testid={f.testid}
                value={display}
                onChange={(e) => onEdit(f.key, e.target.value)}
                placeholder="0"
                className={cn(
                  "h-14 rounded-xl border-slate-700 bg-slate-900/60 pr-11 text-right font-mono text-lg font-bold text-white focus-visible:ring-orange-500/60",
                  active && "border-orange-500/70 bg-orange-500/5"
                )}
              />
              <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-[10px] font-bold uppercase text-slate-500">
                {f.unit}
              </span>
            </div>
          </label>
        );
      })}
    </div>
  );
}
